import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-backupwallet',
  templateUrl: './backupwallet.component.html',
  styleUrls: ['./backupwallet.component.css']
})
export class BackupwalletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
